import React from 'react';

import { Browser, detectBrowser } from '@/helpers/browser.helpers';

export default function useBrowser() {
  const [browser, setBrowser] = React.useState<Browser | null>(null);

  React.useEffect(() => {
    setBrowser(detectBrowser());
  }, []);

  return browser;
}
